import { getCommonAxiosCommon, UrlBuilder } from 'app/helpers/MiscUtils';
import { NgAPIResponse } from 'app/types';
import axios from 'axios';
import { config } from 'config';

export interface JobseekerRegistration {
  organizationId: string
  jobFairId: string
  id: string
  createdAt?: string
  /* eslint-disable camelcase */
  email?: string
  given_name?: string
  family_name?: string
  phone_number?: string
  /* eslint-enable camelcase */
}

const EndPoints = {
  JobseekerRegistrations: `${config.vjfpNGRestAPI}/organizations/jobseeker-registrations`
};

export class JobseekerRegistrationService {
  async getRegistration (
    organizationId: string,
    jobFairId: string,
    id: string
  ): Promise<JobseekerRegistration> {
    const result = await axios.get<NgAPIResponse<JobseekerRegistration>>(
      UrlBuilder(`${EndPoints.JobseekerRegistrations}/:organizationId/:jobFairId/:id`, {
        organizationId,
        jobFairId,
        id
      }),
      await getCommonAxiosCommon()
    );
    return result.data.data;
  }

  async getAllByOrganization (organizationId: string): Promise<JobseekerRegistration[]> {
    const result = await axios.get<NgAPIResponse<JobseekerRegistration[]>>(
      UrlBuilder(`${EndPoints.JobseekerRegistrations}/:organizationId`, { organizationId }),
      await getCommonAxiosCommon()
    );
    return result.data.data;
  }

  async createRegistration (
    organizationId: string,
    jobFairId: string,
    id: string,
    registrationData: Omit<JobseekerRegistration, 'organizationId' | 'jobFairId' | 'id'>
  ): Promise<JobseekerRegistration> {
    const result = await axios.post<NgAPIResponse<JobseekerRegistration>>(
      EndPoints.JobseekerRegistrations,
      { organizationId, jobFairId, id, registrationData },
      await getCommonAxiosCommon()
    );
    return result.data.data;
  }

  async getExcelDownload (organizationId: string): Promise<string | undefined> {
    const result = await axios.get<NgAPIResponse<string>>(
      UrlBuilder(`${EndPoints.JobseekerRegistrations}/:organizationId/excel-download`, {
        organizationId
      }),
      await getCommonAxiosCommon()
    );

    return result.data.data;
  }
}
